import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Customer } from "../../../types/Customer";

export interface AppProps {
  loading: boolean;
  customerData: Customer | null;
}

const initialState: AppProps = {
  loading: false,
  customerData: null,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setCustomerData: (state, action: PayloadAction<Customer>) => {
      state.customerData = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    reset: (state) => {
      state.loading = initialState.loading;
      state.customerData = initialState.customerData;
    },
  },
});

export const { setCustomerData, setLoading, reset } = appSlice.actions;
export default appSlice.reducer;
